import { render, staticRenderFns } from "./DialogModel.vue?vue&type=template&id=0e064213&scoped=true"
import script from "./DialogModel.vue?vue&type=script&lang=js"
export * from "./DialogModel.vue?vue&type=script&lang=js"
import style0 from "./DialogModel.vue?vue&type=style&index=0&id=0e064213&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e064213",
  null
  
)

export default component.exports